require("navigation");
require("components/equal-height");

require("components/fixed-nav");

//----- vars
window.isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) ? true : false;
window.isMobile = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
|| /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4)) ? true : false;

function $_GET(_param) {
  var vars = {};
  window.location.href.replace( location.hash, '' ).replace(
    /[?&]+([^=&]+)=?([^&]*)?/gi, // regexp
    function( m, key, value ) { // callback
      vars[key] = value !== undefined ? value : '';
    }
    );

  if ( _param ) {
    return vars[_param] ? vars[_param] : null;
  }
  return vars;
}

function heightLinkFlatsList(){
  var heightImg =$('.flatbox-img img').outerHeight();
  $('.flatbox-imgcontainer').css('height', heightImg);
}

// Loader détail lot
function loaderDetailLot(){
  var loader = $('.loader');

  if (window.matchMedia("(max-width: 480px)").matches) {
    /* the view port is at least 480px wide */
    $('.lot-slider .flexslider').css('height', 267+'px');

  } else if (window.matchMedia("(max-width: 768px)").matches) {
    /* the view port is at least 768px wide */
    $('.lot-slider .flexslider').css('height', 427+'px');

  }else if (window.matchMedia("(max-width: 992px)").matches) {
    /* the view port is at least 992px wide */
    $('.lot-slider .flexslider').css('height', 331+'px');

  } else if (window.matchMedia("(max-width: 1200px)").matches) {
    /* the view port is at least 1200 pixels wide */
    $('.lot-slider .flexslider').css('height', 400+'px');

  } else if (window.matchMedia("(min-width: 1201px)").matches){
    /* C'est que nous sommes au dessus de 1200px */
    $('.lot-slider .flexslider').css('height', 500+'px');
  }
  
  $(window).on('load', function() {
    // your code here
    var heightViewport = $('.lot-slider .flex-viewport').outerHeight();
    $('.lot-slider-nav').css('top', 10);

    loader.animate({height: heightViewport}, '400', function(){
      $('.lot-slider .flexslider').css('height', '');
      $('.lot-slider-nav').css('top', '');
      loader.delay('300').fadeOut('400', function() {
        $(this).remove();
      });
    })
  });

}

//Loader pour les résidences
function loaderDetailresidence(){
  var loader = $('.loader');

  if (window.matchMedia("(max-width: 480px)").matches) {
    /* the view port is at least 480px wide */
    $('.residence-slider .flexslider').css('height', 225+'px');

  } else if (window.matchMedia("(max-width: 768px)").matches) {
    /* the view port is at least 768px wide */
    $('.residence-slider .flexslider').css('height', 360+'px');

  }else if (window.matchMedia("(max-width: 992px)").matches) {
    /* the view port is at least 992px wide */
    $('.residence-slider .flexslider').css('height', 465+'px');

  } else if (window.matchMedia("(max-width: 1200px)").matches) {
    /* the view port is at least 1200 pixels wide */
    $('.residence-slider .flexslider').css('height', 550+'px');

  } else {
    /* C'est que nous sommes au dessus de 1200px */
    $('.residence-slider .flexslider').css('height', 700+'px');
  }
  
  $(window).on('load', function() {
    // your code here
    var heightViewport = $('.residence-slider .flex-viewport').outerHeight();
    $('.residence-slider-nav').css('top', 10);

    loader.animate({height: heightViewport}, '400', function(){
      $('.residence-slider .flexslider').css('height', '');
      $('.residence-slider-nav').css('top', '');
      loader.delay('300').fadeOut('400', function() {
        $(this).remove();
      });
    })
  });

}

function placementWarningCookies(){
  var bandeau = $('#cookies');
  var button = $('#cookies a');
  if (bandeau.length) {

    if (window.matchMedia("(max-width: 490px)").matches) {
      $('header').css('padding-top', '80px');
      $('header.fixed').css('padding-top', '95px');
    } else if (window.matchMedia("(max-width: 600px)").matches) {
      $('header').css('padding-top', '60px');
      $('header.fixed').css('padding-top', '80px');
    } else if (window.matchMedia("(max-width: 768px)").matches) {
      $('header').css('padding-top', '50px');
      $('header.fixed').css('padding-top', '70px');
    } else if (window.matchMedia("(max-width: 992px)").matches) {
      $('header.fixed').css('padding-top', '60px');
    } else {
      $('header').css('padding-top', '40px');
    }

    button.on('click', function() {
      $('header').css('padding-top', '0');
    });
  }
}

function initHomePropertyBlock(){
  let $blocks = $('.home-property-list-wrapper');
  $blocks.each(function(){
    let $block = $(this);
    let total = $block.data('total');
    if(total > 0){

      $block.flexslider({
        animation: "slide",
        slideshow: false,
        controlNav: false,   // Active la pagination (points sous le slider)
        directionNav: true, // Active les flèches (précédent/suivant)
        itemWidth: 300,     // Largeur de chaque slide (peut être ajusté)
        minItems: 1,        // Minimum de slides visibles
        maxItems: 4,        // Maximum de slides visibles
      });
    }
  });
}

$(document).ready(function() {
  if (window.matchMedia("(max-width: 340px)").matches) {
    /* the view port is at least 340 pixels wide */
    heightLinkFlatsList()
  }

  placementWarningCookies();
  
  /* Lancement du loader */
  loaderDetailLot();
  loaderDetailresidence();

  /*META DONNEES*/
  if ($('[data-meta-description]').length) {
    $("meta[name='description']").attr("content", $('[data-meta-description]').data('meta-description'));
    $("title").html($('[data-title]').data('title'));
  }

  if ($('.style-description').length) {
    var h2 = $('.style-description h2');
    for (var i = 0; i < h2.length; i++) {
      $(h2[i]).addClass('h2-'+(i+1))
    }
  }
  /* Js for landing page */
  if(!$('.landing-header div').hasClass("landing-landscape")){
    var marginBottomLandingHeading = $('.landing-heading').outerHeight()/2;
    $('.landing-heading').css({
      "margin-bottom":-marginBottomLandingHeading
    });

    var container = $(".vc_row.wpb_row.vc_row-fluid.row-with-bg-grey");

    var column = $(container[0]).find(".vc_column_container.vc_col-sm-4, .vc_column_container.vc_col-sm-6");
    $(column).each(function() {
      var landingPage = $(this).find(".wpb_wrapper").children();
      $(landingPage).each(function(index) {
        if (!$(this).hasClass('wpb_single_image') && index == 0) {
          if ($(this).hasClass("landing-page")) {
            $(this).css({
              "padding-top":marginBottomLandingHeading
            });
          } else {
            $(this).find('.landing-page').css({
              "padding-top":marginBottomLandingHeading
            });
          }
        }
      })
    })
    // var landingPageFirst = $(".wpb_column.vc_column_container.vc_col-sm-4").children(".landing-page")
    // $(landingPageFirst[0]).css({
    //   "padding-top":marginBottomLandingHeading
    // });
  }

  /*TWITTER CARD*/
  if ($('[data-meta-description]').length && $('.lot .top-h1').length) {
    $("meta[property='og:title']").attr("content", $('[data-title]').data('title'));
    $("meta[name='twitter:title']").attr("content", $('[data-title]').data('title'));

    $("meta[property='og:url'").attr("content", window.location.href);

    if (!$("meta[property='og:image'").length) {
      $('head').append('<meta property="og:image" content="'+$('.slides li img').attr('src')+'" />');
    } else {
      $("meta[property='og:image'").attr("content", $('.slides li img').attr('src'));
    }

    if (!$("meta[name='twitter:image'").length) {
      $('head').append('<meta name="twitter:image" content="'+$('.slides li img').attr('src')+'" />');
    } else {
      $("meta[name='twitter:image'").attr("content", $('.slides li img').attr('src'));
    }
  }

  /*TWITTER CARD*/
  if ($('[data-meta-description]').length && $('.residence .top-h1').length) {
    $("meta[property='og:title']").attr("content", $('[data-title]').data('title'));
    $("meta[name='twitter:title']").attr("content", $('[data-title]').data('title'));

    $("meta[property='og:url'").attr("content", window.location.href);

    if (!$("meta[property='og:image'").length) {
      $('head').append('<meta property="og:image" content="'+$('.slides li img').attr('src')+'" />');
    } else {
      $("meta[property='og:image'").attr("content", $('.slides li img').attr('src'));
    }

    if (!$("meta[name='twitter:image'").length) {
      $('head').append('<meta name="twitter:image" content="'+$('.slides li img').attr('src')+'" />');
    } else {
      $("meta[name='twitter:image'").attr("content", $('.slides li img').attr('src'));
    }
  }



  if ($('.wpcf7-form-control-wrap select').length) {
    $('.wpcf7-form-control-wrap select').parent().addClass("input-select");
  }

  if ($('.date-only-month-year input[type="date"]').length) {
    $('.date-only-month-year input[type="date"]').attr('type', 'month');
  }


  /* LANDING PAGE form id event */
  if ($('.page-header-h1-top-h1').length && $('#idevent').length) {
    $('#idevent').attr('value', $('.page-header-h1-top-h1').html());
  }

  if ($_GET("id")) {
    $('#idlot').attr('value', $_GET("id"));
  }

  //lightbox
  $("p").find("a:has(img)").addClass('fancybox');
  $("figure").find("a:has(img)").addClass('fancybox');
  $("p").find("a:has(img)").attr('rel','group1');
  $(".fancybox").fancybox( {
    fitToView   : true,
    autoSize    : true,
    autoHeight  : true,
    closeClick  : false,
    openEffect  : 'none',
    closeEffect : 'none',
    padding         : 10,
    helpers     : {
      title   : { type : 'float' },
      buttons : {}
    }
  } );
  $("a.group").fancybox({'transitionIn':'elastic','transitionOut':'elastic','speedIn':600,'speedOut':200,'overlayShow':false});

}); //fin ready


var ie10or11 = (navigator.userAgent.match(/MSIE 10/i)) || (navigator.userAgent.match(/Trident\/7\./));
if(ie10or11){
	var head  = document.getElementsByTagName('head')[0];
	var link  = document.createElement('link');
	link.rel  = 'stylesheet';
	link.type = 'text/css';
	link.href = '/public/stylesheets/ie1011.css';
	link.media = 'all';
	head.appendChild(link);
}


//***** fake hover
$( ".flatbox-link" ).hover(
	function() {
		$( this ).closest('.flatbox-content').addClass( "hover" );
	}, function() {
		$( this ).closest('.flatbox-content').removeClass( "hover" );
	}
	);

$( ".newsbloc a" ).not('.newsbloc-cat a').hover(
	function() {
		$( this ).closest('.newsbloc-col').addClass( "hover" );
	}, function() {
		$( this ).closest('.newsbloc-col').removeClass( "hover" );
	}
	);


//***** hover entrées home
$('.top-entries-link').hover(function() {
	$('.top-entries-link').not(this).addClass('hide');
}, function() {
	$('.top-entries-link').not(this).removeClass('hide');
});


var wow = new WOW(
{
	boxClass:     'mv',
    // offset:       300,
    offset:       100,          // distance to the element when triggering the animation (default is 0)
    mobile:       false,       // trigger animations on mobile devices (default is true)
  }
  );
wow.init();


//***** display mobile & desktop
var mobileArray = document.querySelectorAll('.formobile');
var desktopArray = document.querySelectorAll('.fordesktop');

if (!window.test.ismobileandtablette) {
  for (var i = 0; i < mobileArray.length; i++) {
    mobileArray[i].style.display = "none";
  }
  for (var i = 0; i < desktopArray.length; i++) {
    desktopArray[i].style.display = "inherit";
  }
}else{
  for (var i = 0; i < mobileArray.length; i++) {
    mobileArray[i].style.display = "inherit";
  }
  for (var i = 0; i < desktopArray.length; i++) {
    desktopArray[i].style.display = "none";
  }
}

$('[data-href]').click(function (e) {
  var link = $(this).data('href');
  document.location.href = link;
})


var max_height = 0;
var max_height_actu = 0;

function sameHeightFlatbox() {
  if (screen.width > 768) {
    max_height = 0;
    $('.flatbox-content').css('height', '');
    $('.flatbox-col').each(function () {
      var current_height = $(this).outerHeight();
      if (max_height < current_height) {
        max_height = current_height;
      }
    })
    $('.flatbox-content').css('height', max_height+'px');

// if (window.innerWidth < 1200) {
//     max_height_bblue = 0;
//     $('.bblue-height').css('height', '');
//     $('.bblue-height .col').each(function () {
//       var current_height = $(this).outerHeight();
//       if (max_height_bblue < current_height) {
//         max_height_bblue = current_height;
//       }
//     })
//     $('.bblue-height').css('height', max_height_bblue+'px');
// }
    max_height_actu = 0;
    $('.newsbloc-container').css('height', '');
    $('.newsbloc-col').each(function () {
      var current_height = $(this).outerHeight();
      if (max_height_actu < current_height) {
        max_height_actu = current_height;
      }
    })
    $('.newsbloc-container').css('height', max_height_actu+'px');
  }
}
$(window).load(function () {

 $('#slider').flexslider({
  animation: "slide",
  controlNav: false,
  animationLoop: false,
  slideshow: false,
  sync: "#carousel",
  start: function(slider){
    console.log('start',slider);

      // Initialisation de FancyBox
      $('[data-fancybox="gallery"]').fancybox({
        loop: true, // Permet de revenir à la première image après la dernière
        buttons: [
            "zoom",
            "slideShow",
            "fullScreen",
            "thumbs",
            "close"
        ]
    });
  }
}); 

 $('#carousel').flexslider({
  animation: "slide",
  controlNav: false,
  directionNav: false,
  animationLoop: false,
  slideshow: false,
  itemWidth: 110,
  itemMargin: 5,
  asNavFor: '#slider'
})
 //$('#carousel').css('display', 'inline-block');

/*
  $('body').on('click', '#slider .flex-active-slide', function(event) {
    console.log('click',event);
    
    let $item = $(this);
    let $img = $('img', $item);
    let src = $img.attr('src');
    //$.fancybox.open(src);
  });
*/
  $('.datepicker').datepicker({
    minDate: 0,
    dateFormat: "dd/mm/yy"
  });


 sameHeightFlatbox()


// Calcul du ratio pour les résidence et application de la hauteur
function heightResidence(){
  var width = $('.lot').width();
  var baseW = 1495;
  var baseH = 440;
  $('.lot-residence').css("height", (baseH*width)/baseW+"px");
}

// Calcul du ratio pour les résidence et application de la hauteur
function heightDestination(){
  var width = $('.residence').width();
  var baseW = 1495;
  var baseH = 440;
  $('.residence-destination').css("height", (baseH*width)/baseW+"px");
}

if ($('.lot-residence-wrapper').length) {
  var pad = parseInt($('.lot-residence-wrapper').css('padding-top'))+parseInt($('.lot-residence-wrapper').css('padding-bottom'));
  var h = $('.lot-residence--title').outerHeight()+$('.lot-residence--description').outerHeight();
  $('.lot-residence-wrapper').css('height', h+pad+'px');
  heightResidence();
}
  //$('.lot-wrapper').css('min-height', $('.lot-container-fixed').outerHeight()+'px');

  if ($('.residence-destination-wrapper').length) {
    var pad = parseInt($('.residence-destination-wrapper').css('padding-top'))+parseInt($('.residence-destination-wrapper').css('padding-bottom'));
    var h = $('.residence-destination--title').outerHeight()+$('.residence-destination--description').outerHeight();
    $('.residence-destination-wrapper').css('height', h+pad+'px');
    heightDestination();
  }

  $('.residence-wrapper').css('min-height', $('.residence-container-fixed').outerHeight()+'px');

  $(window).resize(function () {
    if (window.matchMedia("(max-width: 340px)").matches) {
      /* the view port is at least 340 pixels wide */
      heightLinkFlatsList()
    }

    placementWarningCookies();

    if ($('.landing-heading').length) {
      $('.landing-heading').css("margin-bottom", -$('.landing-heading').outerHeight()/2);
    }

    if ($('.lot-residence-wrapper').length) {
      var pad = parseInt($('.lot-residence-wrapper').css('padding-top'))+parseInt($('.lot-residence-wrapper').css('padding-bottom'));
      var h = $('.lot-residence--title').outerHeight()+$('.lot-residence--description').outerHeight();
      heightResidence();
    }
    $('.lot-wrapper').css('min-height', $('.lot-container-fixed').outerHeight()+'px');

    if ($('.residence-destination-wrapper').length) {
      var pad = parseInt($('.residence-destination-wrapper').css('padding-top'))+parseInt($('.residence-destination-wrapper').css('padding-bottom'));
      var h = $('.residence-destination--title').outerHeight()+$('.residence-destination--description').outerHeight();
      $('.residence-destination-wrapper').css('height', h+pad+'px');
      heightDestination();
    }
    $('.residence-wrapper').css('min-height', $('.residence-container-fixed').outerHeight()+'px');

    sameHeightFlatbox();


  })



});

(function($) {

  /*
  *  new_map
  *
  *  This function will render a Google Map onto the selected jQuery element
  *
  *  @type  function
  *  @date  8/11/2013
  *  @since 4.3.0
  *
  *  @param $el (jQuery element)
  *  @return  n/a
  */

  function new_map( $el ) {

    // var
    var $markers = $el.find('.marker');

    // vars
    var args = {
      zoom    : 16,
      center    : new google.maps.LatLng(0, 0),
      mapTypeId : google.maps.MapTypeId.ROADMAP,
      streetViewControl: false,
      scaleControl: true,
      scrollwheel: false,
      zoomControl: true,
      mapTypeControl: false,
      disableDefaultUI: true,
      mapTypeControlOptions: {mapTypeIds: [google.maps.MapTypeId.ROADMAP, 'map_style'],}
    };


    // create map
    var map = new google.maps.Map( $el[0], args);

    // styles map
    var styles = [
    {
      'stylers': [
      { 'saturation': 1 },
      { 'hue': '#00ffff' }
      ]
    }
    ];
    var styledMap = new google.maps.StyledMapType(styles,{name: 'Styled Map'});
    map.mapTypes.set('map_style', styledMap);
    map.setMapTypeId('map_style');


    // add a markers reference
    map.markers = [];


    // add markers
    $markers.each(function(){

      add_marker( $(this), map );

    });


    // center map
    center_map( map );


    // return
    return map;

  }

  /*
  *  add_marker
  *
  *  This function will add a marker to the selected Google Map
  *
  *  @type  function
  *  @date  8/11/2013
  *  @since 4.3.0
  *
  *  @param $marker (jQuery element)
  *  @param map (Google Map object)
  *  @return  n/a
  */

  function add_marker( $marker, map ) {

    // var
    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

    // create marker
    var marker = new google.maps.Marker({
      position  : latlng,
      map     : map
    });

    // add to array
    map.markers.push( marker );

    // if marker contains HTML, add it to an infoWindow
    if( $marker.html() )
    {
      // create info window
      var infowindow = new google.maps.InfoWindow({
        content   : $marker.html()
      });

      // show info window when marker is clicked
      google.maps.event.addListener(marker, 'click', function() {

        infowindow.open( map, marker );

      });
    }

  }

  /*
  *  center_map
  *
  *  This function will center the map, showing all markers attached to this map
  *
  *  @type  function
  *  @date  8/11/2013
  *  @since 4.3.0
  *
  *  @param map (Google Map object)
  *  @return  n/a
  */

  function center_map( map ) {

    // vars
    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each( map.markers, function( i, marker ){

      var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

      bounds.extend( latlng );

    });

    // only 1 marker?
    if( map.markers.length == 1 )
    {
      // set center of map
      map.setCenter( bounds.getCenter() );
      map.setZoom( 16 );
    }
    else
    {
      // fit to bounds
      map.fitBounds( bounds );
    }

  }

  /*
  *  document ready
  *
  *  This function will render each map when the document is ready (page has loaded)
  *
  *  @type  function
  *  @date  8/11/2013
  *  @since 5.0.0
  *
  *  @param n/a
  *  @return  n/a
  */
  // global var
  var map = null;

  $(document).ready(function(){

    $('.acf-map').each(function(){

      // create map
      map = new_map( $(this) );

    });

    if ($('.breadcrumb-destination').length && $('.flatbox').length) {
      $('.breadcrumb-destination').parent().addClass('flatsfix');
      $('.flats-title').css('color','#ffffff');
    } 
    if ($('.page-header.image').length && !$('.flatbox').length) {
      $('.page-header').addClass('noflats');
    }
    initHomePropertyBlock();
 });

})(jQuery);
